// 認証ストアモジュール

const TOKEN_EXPIRATION_HOURS = 12;

export default {
    namespaced: true,
  
    state: {
      user: null,
      isAuthenticated: false,
      expiresAt: null,
      autoPrintEnabled: false
    },
  
    mutations: {
      SET_USER(state, userData) {
        state.user = userData;
        state.isAuthenticated = !!userData;
        
        const expiresAt = new Date();
        expiresAt.setHours(expiresAt.getHours() + TOKEN_EXPIRATION_HOURS);
        state.expiresAt = expiresAt.getTime();
        
        if (userData) {
          localStorage.setItem('user', JSON.stringify(userData));
          localStorage.setItem('expiresAt', state.expiresAt);
        }
      },
  
      LOGOUT(state) {
        state.user = null;
        state.isAuthenticated = false;
        state.expiresAt = null;
        
        localStorage.removeItem('user');
        localStorage.removeItem('expiresAt');
        localStorage.removeItem('accountName');
        localStorage.removeItem('token');

        sessionStorage.removeItem('printButtonEnabled');
      },
      
      RESTORE_AUTH(state) {
        const userStr = localStorage.getItem('user');
        const expiresAt = localStorage.getItem('expiresAt');
        const token = localStorage.getItem('token');
        const accountName = localStorage.getItem('accountName');
        
        if (token) {
          if (userStr && expiresAt) {
            const now = new Date().getTime();
            
            if (now < parseInt(expiresAt)) {
              state.user = JSON.parse(userStr);
              state.isAuthenticated = true;
              state.expiresAt = parseInt(expiresAt);

            } else {
              state.user = null;
              state.isAuthenticated = false;
              state.expiresAt = null;
              localStorage.removeItem('user');
              localStorage.removeItem('expiresAt');
              localStorage.removeItem('accountName');
              localStorage.removeItem('token');

              sessionStorage.removeItem('printButtonEnabled');
            }
          } else if (accountName) {
            const expiresAt = new Date();
            expiresAt.setHours(expiresAt.getHours() + TOKEN_EXPIRATION_HOURS);
            
            const userData = { accountName: accountName };
            state.user = userData;
            state.isAuthenticated = true;
            state.expiresAt = expiresAt.getTime();
            
            localStorage.setItem('user', JSON.stringify(userData));
            localStorage.setItem('expiresAt', state.expiresAt);
          }
        } else {
          state.user = null;
          state.isAuthenticated = false;
          state.expiresAt = null;

          sessionStorage.removeItem('printButtonEnabled');
        }
      }
    },
  
    actions: {
      setUser({ commit }, userData) {
        commit('SET_USER', userData);
      },
  
      logout({ commit }) {
        commit('LOGOUT');
      },
      
      restoreAuth({ commit }) {
        commit('RESTORE_AUTH');
      },
      
      checkAuth({ state, commit }) {
        if (state.expiresAt) {
          const now = new Date().getTime();
          if (now >= state.expiresAt) {
            commit('LOGOUT');
            return false;
          }
          return true;
        }
        return !!state.isAuthenticated;
      }
    },
  
    getters: {
      currentUser: state => state.user,
      isAuthenticated: state => state.isAuthenticated,
      authExpiration: state => state.expiresAt,
    }
};
